import { Dialog } from '@myosh/odin-components'
import ViewNameEditor from './view-name-editor'
import './view-management.scss'
import type { GapAnalysisViewDto, TrainingMatrixViewDto } from '../../../API/rtk-query-api/store/tmsApi'

interface ViewManagementModalProps {
  isModalVisible: boolean
  viewsToManage: Array<TrainingMatrixViewDto | GapAnalysisViewDto>
  onRemoveView: (view: TrainingMatrixViewDto | GapAnalysisViewDto) => void
  onRenameView: (view: TrainingMatrixViewDto | GapAnalysisViewDto) => void
  onHideModal: () => void
}

function ViewManagementModal({
  isModalVisible,
  viewsToManage,
  onRemoveView,
  onHideModal,
  onRenameView
}: ViewManagementModalProps) {
  const handleViewRename = (view: TrainingMatrixViewDto | GapAnalysisViewDto) => {
    onRenameView(view)
  }

  const handleRemoveView = (view: TrainingMatrixViewDto | GapAnalysisViewDto) => {
    onRemoveView(view)
  }

  return (
    <>
      {isModalVisible && (
        <Dialog header='Manage Views' visible={isModalVisible} onClose={onHideModal}>
          <>
            {viewsToManage.map((view, index) => {
              return (
                <ViewNameEditor
                  key={view.id}
                  view={view}
                  isEven={index % 2 === 0}
                  onChange={handleViewRename}
                  onRemove={handleRemoveView}
                />
              )
            })}
          </>
        </Dialog>
      )}
    </>
  )
}

export default ViewManagementModal
